import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/showroom-loader_center.gif")